import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MapComponent, DrawingModes } from '../map.component';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { environment } from '@env/environment';

@Component({
  selector: 'app-map-controls',
  standalone: true,
  imports: [
    MatButtonModule,
    MatCardModule,
    MatGridListModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule
  ],
  templateUrl: './map-controls.component.html',
  styleUrl: './map-controls.component.css'
})
export class MapControlsComponent {
  public latitude: number;
  public longitude: number;
  public DrawingModes = DrawingModes;

  constructor(
    private baseMap: MapComponent
  ) {
    this.latitude = environment.home.coordinates[1];
    this.longitude = environment.home.coordinates[0];
  }

  setCenter() {
    this.baseMap.setCenter(this.latitude, this.longitude);
  }

  clearLatLon() {
    this.latitude = environment.home.coordinates[1];
    this.longitude = environment.home.coordinates[0];
  }

  gotoHome() {
    this.baseMap.setCenter(environment.home.coordinates[1], environment.home.coordinates[0]);
  }

  zoomIn() {
    this.baseMap.setZoom(this.baseMap.mapZoom + 1);
  }

  zoomOut() {
    this.baseMap.setZoom(this.baseMap.mapZoom - 1);
  }

  setDrawingMode(mode: DrawingModes) {
    this.baseMap.setDrawingMode(mode);
  }
}
